import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template-layout',
  templateUrl: './template-layout.component.pug',
  styleUrls: ['./template-layout.component.scss']
})
export class TemplateLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
